import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ContentPageModel } from '../model/models';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class HomeService {

  constructor(private http : HttpClient) { }

  getHomePage(userSessionId : number):Observable<ContentPageModel>{
    const params = new HttpParams()
  .set('sessionID', userSessionId.toString());
    return this.http.get<ContentPageModel>(environment.server_url+"/api/HomePage", {params});
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts